import { render, staticRenderFns } from "./tourismPublicOpiniocScreen.vue?vue&type=template&id=d321191c&scoped=true&"
import script from "./tourismPublicOpiniocScreen.vue?vue&type=script&lang=js&"
export * from "./tourismPublicOpiniocScreen.vue?vue&type=script&lang=js&"
import style0 from "./tourismPublicOpiniocScreen.vue?vue&type=style&index=0&id=d321191c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d321191c",
  null
  
)

export default component.exports